import React, { useContext } from 'react';
import {
    TextInput, ReferenceInput,
    AutocompleteInput, useDataProvider,
    BooleanInput
} from 'react-admin';
import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { ReadOnlyContext } from '../../lib/context/ReadOnlyContext';
import { useAzureADGroups } from '../../msal/useAzureADGroups';
import { useParams } from 'react-router-dom';
export const StaffInput = ({ teamName, formData, getSource, scopedFormData }) => {
    const readonly = useContext(ReadOnlyContext) || false
    const { isHeadOfSubject } = useAzureADGroups();
    const { setValue } = useFormContext();
    const dataProvider = useDataProvider();

    let isHistoric = false;
    const params = useParams();
    if(params.id?.length > 10){
        isHistoric = true;
    }

    const onChange = (userId) => {
        dataProvider
            .getMany('User', { ids: [userId] })
            .then(({ data }) => {
                const currentIndex = formData[teamName].indexOf(scopedFormData);
                const { name, surname, userName, jobTitle, accountEnabled, email } = data[0];
                setValue(`${teamName}.${currentIndex}.name`, name);
                setValue(`${teamName}.${currentIndex}.surname`, surname);
                setValue(`${teamName}.${currentIndex}.email`, email);
            })
            .catch((error) => {
                console.error('error =>', error);
            });
    };

    return (
        <>
            <Box display="flex" width={1}>
                <Box flex={2}>
                    <ReferenceInput
                        reference="User"
                        source={getSource('userID')}>
                        <AutocompleteInput 
                            optionText="email"
                            label="Search User Email"
                            onChange={onChange}
                            disabled={(readonly && !isHeadOfSubject) || (readonly && isHistoric)}
                            fullWidth />
                    </ReferenceInput>
                </Box>
            </Box>
            <Box display="flex" width={1}>
                <Box flex={2}>
                    <TextInput source={getSource('name')} disabled={(readonly && !isHeadOfSubject) || (readonly && isHistoric)} fullWidth/>
                </Box>
                <Box flex={2} ml="0.5em">
                    <TextInput source={getSource('surname')} disabled={(readonly && !isHeadOfSubject) || (readonly && isHistoric)} fullWidth/>
                </Box>
                <Box flex={3} ml="0.5em">
                    <TextInput source={getSource('email')} disabled={(readonly && !isHeadOfSubject) || (readonly && isHistoric)} fullWidth/>
                </Box>
            </Box>
        </>
    );
};
